<form class="form form--embedded" [formGroup]="importCoursesForm" (ngSubmit)="onSubmit(importCoursesForm.value)">
	<fieldset>
		<legend class="legend">Import Course</legend>
      	<div class="field">
	      <div class="field__label-input-wrap">
          	<label for="aarcNumber" class="label">AARC Membership Number</label>
			  <input class="input input--medium" id="aarcNumber" [class.input--invalid]="formErrors.aarcNumber" formControlName="aarcNumber" maxlength="15" >
			  <div *ngIf="formErrors.aarcNumber" class="error-message field__error-message">{{ formErrors.aarcNumber }}</div>
	      </div>
    	</div>
		<div class="form-actions">
			<input class="button form-actions__item" type="submit" value="Import" />
			<button (click)="onCancel($event)" class="button button--secondary form-actions__item">Cancel</button>
		</div>
		<div *ngIf="formLevelErrors" class="error-message field__error-message">
            <p *ngFor="let error of formLevelErrors">{{error}}</p>
        </div>
	</fieldset>
</form>